import { IntlShape } from "react-intl";

export const intlFormatPrice = (intl: IntlShape, price: number) => {
  return intl.formatNumber(price, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};
